
(function () {
    'use strict';
  
    /**
     * @ngdoc object
     * @name complaints.controller:ComplaintsCtrl
     *
     * @description
     *
     */
    angular
      .module('cards')
      .controller('CardsOverviewCtrl', CardsOverviewCtrl);
  
    function CardsOverviewCtrl($q, AlertService, HelperService, CardsService, $state, $log, $filter) {
      var vm = this;

      vm.cards = [];
      
      vm.cardsFilter = {
        page: 0,
        pageSize: 100,
        orderBy: 'cardHolder desc,cardNumber'
      };
      vm.isNuN = HelperService.isNuN;

      vm.goToCard = function(card) {
        var errorMessage = HelperService.navigateCardIfPossible(card);
        if (errorMessage) {
          AlertService.successAlert({ message: errorMessage, hideIcon: true });
          return;
        }
        $state.go('card', {
          cardId: card.cardId
        })
      }

      function getCards() {
        CardsService.getPage(vm.cardsFilter)
        .then(function (response) {
          response.result = $filter('orderBy')(response.result, ['-isFavorite', '-isOwn', '-accountType.group'])
          vm.cards = response.result;
        })
        .catch(function (error) {
          $log.error(error);
        });
      }

      function init() {
        getCards();
      }

      init();
    }
}());